module.exports = __webpack_public_path__ + "media/icf/pcc-9ffab0e1.png";